import { FormattedMessage, useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";

import { formatRegisteredSymbol } from "./utils";

const EnterpriseAgility = () => {
    const intl = useIntl();
    return (
        <TabsContent
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.makeAllWorkVisible",
                        defaultMessage: "Make all work visible in real-time"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.makeAllWorkVisible.bodytext",
                        defaultMessage:
                            "Spot and solve blockers faster with visibility into all work from teams across your enterprise."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.alignEveryTeam",
                        defaultMessage: "Align every team to strategy"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.alignEveryTeam.bodyText",
                        defaultMessage:
                            "Get everyone on the same page so you can solve for dependencies, scope, and roadmaps across teams and portfolios."
                    })
                },
                {
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.stayFocusedOnCustomerValue",
                        defaultMessage: "Stay focused on customer value"
                    }),
                    headerType: "h4",
                    bodyText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.stayFocusedOnCustomerValue.bodyText",
                        defaultMessage:
                            "Map investments to customer value creation so you can make confident decisions at make-or-break moments."
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.Agility.learnMore",
                    defaultMessage: "Learn about enterprise agility"
                }),
                link: useLocalizedHref("/software/jira/align"),
                linkLabel: "Learn about enterprise agility",
                productKey: "enterprise"
            }}
            pictureProps={{
                image: {
                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterpriseAgilityTab-3288956471.webp",
                    alt: ""
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "EnterpriseLandingPage.tab.Agility.resources",
                defaultMessage: "Enterprise agility resources"
            })}
            cardsContent={[
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.card.forresterReport",
                        defaultMessage: "Report"
                    }),
                    headerText: (
                        <FormattedMessage
                            id="EnterpriseLandingPage.tab.Agility.card.forresterReport.headerText"
                            defaultMessage="Atlassian is a Leader in the 2022 Gartner<sup>®</sup> Magic Quadrant for Enterprise Agile Planning Tools"
                            values={formatRegisteredSymbol}
                        />
                    ),
                    clickableCardUrl: useLocalizedHref("/gartner"),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.Agility.card.forresterReport.linkText",
                            defaultMessage: "Read report"
                        }),
                        type: "basic",
                        href: useLocalizedHref("/gartner"),
                        doesArrowAnimate: true,
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Read report"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-01-report@2x-1971220130.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.card.reportWebinar",
                        defaultMessage: "Demo center"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.card.reportWebinar.headerText",
                        defaultMessage:
                            "Learn how to boost Enterprise Agility with Jira Align"
                    }),
                    clickableCardUrl: useLocalizedHref(
                        "/software/jira/align/demo"
                    ),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.Agility.card.reportWebinar.linkText",
                            defaultMessage: "Explore demos"
                        }),
                        type: "basic",
                        href: useLocalizedHref("/software/jira/align/demo"),
                        doesArrowAnimate: true,
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Explore demos"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-02-demo@2x-3880751788.webp",
                            alt: ""
                        }
                    }
                },
                {
                    eyebrowText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.card.ITSMGuide",
                        defaultMessage: "Whitepaper"
                    }),
                    headerText: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.Agility.card.ITSMGuide.headerText",
                        defaultMessage:
                            "Leading Transformation Through Uncertainty: An Agile Leader’s Primer"
                    }),
                    clickableCardUrl: useLocalizedHref(
                        "/whitepapers/agileleaderprimer"
                    ),
                    ctaProps: {
                        text: intl.formatMessage({
                            id: "EnterpriseLandingPage.tab.Agility.card.ITSMGuide.linkText",
                            defaultMessage: "Read whitepaper"
                        }),
                        type: "basic",
                        href: useLocalizedHref(
                            "/whitepapers/agileleaderprimer"
                        ),
                        doesArrowAnimate: true,
                        dataEventProps: {
                            "data-product-key": "enterprise",
                            "data-event-component": "linkButton",
                            "data-event-container": "resourcesSection",
                            "data-event": "clicked",
                            "data-label-english": "Read whitepaper"
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-03-whitepaper@2x-1054816959.webp",
                            alt: ""
                        }
                    }
                }
            ]}
        />
    );
};

export { EnterpriseAgility };
